import { render, staticRenderFns } from "./mutiselection.vue?vue&type=template&id=615f8cf2&scoped=true&"
import script from "./mutiselection.vue?vue&type=script&lang=js&"
export * from "./mutiselection.vue?vue&type=script&lang=js&"
import style0 from "./mutiselection.vue?vue&type=style&index=0&id=615f8cf2&prod&scoped=true&lang=css&"
import style1 from "./mutiselection.vue?vue&type=style&index=1&id=615f8cf2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615f8cf2",
  null
  
)

export default component.exports